import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useIntercom } from 'react-use-intercom';

import { Alert, Container } from '@dev/ee-components';
import { AlertCenter } from '@dev/ee-modules';

import { useTablet } from '@/services/hooks/useTablet';
import { isIntercomEnabled } from '@/services/Secuirty';
import { SettingsPaths } from '@/services/dictionaries/Paths';
import { HomePaths } from '@/services/dictionaries/Paths';

import { DPAUpdatedBanner } from '@/services/Layout/DPABanner';
import { useReshardingActions } from '@/services/hooks/useReshardingActions';
import { WIDGETS_ORDER, WidgetType, WidgetConfig } from '../../HomeInterface';
import { Widget } from '../../components/Widget';
import { AlertWithCenteredMessage, WidgetArea } from '../../styled';
import { useWidgetConfig } from '../../hooks/useWidgetConfig';
import { SignUpToCreatorsNewsletter } from '../../components/SignUpToCreatorsNewsletter';
import { Welcome } from '../../components/Welcome';

export const CreatorHomePage = (): JSX.Element => {
    const { t } = useTranslation();
    const widgetConfig = useWidgetConfig();
    const isTablet = useTablet();

    const { boot, show } = useIntercom() || {};
    const { checkReshardStatusIfNeeded, reshardHomeAlertConfig } = useReshardingActions();

    useEffect(() => {
        isIntercomEnabled() && boot();
        checkReshardStatusIfNeeded();
    }, []);

    const launchIntercom = () => {
        isIntercomEnabled() && show();
    };

    const getWidgetProps = (widgetKey: WidgetType):WidgetConfig => {
        const config = widgetConfig[widgetKey];
        return {
            title: t(config.title),
            content: config.content,
            isLoading: config.isLoading,
            button: config.button ? {
                ...config.button,
                textKey: t(config.button.textKey)
            } : null,
            isButtonVisible: config.isButtonVisible ? config.isButtonVisible : null,
            useCustomContentLayout: config.useCustomContentLayout
        };
    };

    return (
        <Container>
            <AlertCenter
                paths={{ ...SettingsPaths, ...HomePaths }}
                customNotifications={
                    <>
                        {reshardHomeAlertConfig && (
                            <AlertWithCenteredMessage>
                                <Alert {...(reshardHomeAlertConfig as any)} />
                            </AlertWithCenteredMessage>
                        )}
                        <DPAUpdatedBanner />
                    </>
                }
                launchIntercom={launchIntercom}
            />
            <Welcome />
            <WidgetArea isTablet={isTablet}>
                {WIDGETS_ORDER.map((widgetType, index) => (
                    <Widget
                        key={widgetType}
                        {...getWidgetProps(widgetType)}
                        widgetIndex={index}
                    />
                ))}
            </WidgetArea>
            <SignUpToCreatorsNewsletter />
        </Container>
    );
};